import React from 'react';
import { useDispatch } from 'react-redux';
import { Alert, AlertTitle, IconButton, Tooltip } from '@mui/material';

import { closeDialog } from 'app/store/fuse/dialogSlice';
import { Icon, showConfirmCancelDialog, useSettings, Utils } from 'app/main/components';

export default function OrdersDetailsSectionCheckRows({
	orderUid,
	updateRefresh
}: {
	orderUid: string;
	updateRefresh: () => void;
}) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	function showDialog() {
		dispatch(
			showConfirmCancelDialog({
				title: t('ORDERS_DETAILS_CHECKROWS_DIALOG'),
				onConfirm: () => {
					Utils.executeStored({
						action: 'st_orders_lines_calc',
						dispatch,
						data: { ords_uid: orderUid },
						successHandler: response => {
							dispatch(closeDialog());
							updateRefresh();
						}
					});
				},
				onCancel: () => dispatch(closeDialog())
			})
		);
	}

	return (
		<Alert
			severity="warning"
			sx={theme => ({
				border: `1px solid ${theme.palette.divider}`,
				borderRadius: '8px'
			})}
			action={
				<Tooltip title={t('ORDERS_DETAILS_CHECKROWS_ACTION')} arrow>
					<IconButton color="inherit" onClick={showDialog}>
						<Icon icon="table-refresh" />
					</IconButton>
				</Tooltip>
			}
		>
			<AlertTitle>{t('ORDERS_DETAILS_CHECKROWS_TITLE')}</AlertTitle>
			{t('ORDERS_DETAILS_CHECKROWS_TEXT1')}—&nbsp;
			<strong>{t('ORDERS_DETAILS_CHECKROWS_TEXT2')}</strong>
		</Alert>
	);
}
